import type { PageExperience } from '@/features/experiences/types';
import type { DayContextType } from '@/ui/Calendar/DayContext';
import { FONT_HEADING } from '../../../css/customFonts';
import { getStyleById } from '../../../theme';
import type { GroupData } from '../types';
import { toMonthKey } from '../util.lib';
import { EventItem } from './EventItem';

type Props = {
  dayContext: DayContextType;
  box: GroupData | undefined;
  experience: PageExperience;
};

export const DayCell = ({ dayContext, box, experience }: Props) => {
  const monthKey = toMonthKey({
    month: dayContext.month,
    year: dayContext.year,
  });
  const theme = getStyleById(experience.styleId ?? undefined);
  const isCurrentMonth = dayContext.currentMonth;

  const dayMeasureKey = dayContext.currentMonth
    ? `day-${monthKey}-${dayContext.day}`
    : undefined;
  const dayHeaderMeasureKey = dayContext.currentMonth
    ? `day-header-${monthKey}-${dayContext.day}`
    : undefined;

  return (
    <div
      data-measure={dayMeasureKey}
      style={{
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        width: '100%',
        minHeight: 0,
        minWidth: 0,
        overflow: 'hidden',
        backgroundColor: isCurrentMonth ? '#FFFFFF' : '#F8F8F8',
        opacity: isCurrentMonth ? 1 : 0.5,
        borderRight: `1px solid ${theme.accent2Color || '#E0E0E0'}`,
        borderBottom: `1px solid ${theme.accent2Color || '#E0E0E0'}`,
      }}
    >
      <div
        data-measure={dayHeaderMeasureKey}
        style={{
          padding: '0.25em 0.4em',
          fontFamily: FONT_HEADING,
          fontSize: '0.8em',
          fontWeight: '600',
          textAlign: 'right',
          color: isCurrentMonth ? '#000000' : '#999999',
        }}
      >
        {dayContext.day}
      </div>
      <div
        data-measure={
          dayContext.currentMonth
            ? `day-content-${monthKey}-${dayContext.day}`
            : undefined
        }
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          padding: '0 0.3em 0.3em',
          overflow: 'hidden',
        }}
      >
        {box?.events.map((event, index) => {
          const key = `event-${event.id}-${box.date.toISODate()}`;
          return (
            <div
              data-measure={key}
              key={key}
              style={index > 0 ? { marginTop: '0.2em' } : undefined}
            >
              <EventItem
                date={box.date}
                event={event}
                experience={experience}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
